import { fetchApi } from '@/api/http'

const KEY_ACTIVE = 'agendamentos-app:cliente:active'
const KEY_BEARER = 'agendamentos-app:cliente:bearer'
const LEGACY_TOKEN_KEY = 'agendamentos-app:cliente:token'
const USER_STORAGE_KEY = 'agendamentos-app:user'

function clearLegacyToken(): void {
  try {
    localStorage.removeItem(LEGACY_TOKEN_KEY)
  } catch {
    /* ignore */
  }
}

/** Indica que o cliente deve validar sessão (hint local; a API confirma via cookie/Bearer). */
export function hasClienteSessionHint(): boolean {
  try {
    clearLegacyToken()
    if (sessionStorage.getItem(KEY_ACTIVE) === '1') return true
    if (sessionStorage.getItem(KEY_BEARER)) return true
    const raw = localStorage.getItem(USER_STORAGE_KEY)
    if (!raw) return false
    const data = JSON.parse(raw) as { id?: unknown; email?: unknown }
    return typeof data?.id === 'number' && Boolean(data?.email)
  } catch {
    return false
  }
}

export function markClienteSessionActive(): void {
  try {
    sessionStorage.setItem(KEY_ACTIVE, '1')
    clearLegacyToken()
  } catch {
    /* ignore */
  }
}

/** Token JWT para Authorization Bearer (fallback quando o cookie httpOnly falha no WebView). */
export function setClienteBearerToken(token: string): void {
  const value = String(token || '').trim()
  if (!value) return
  try {
    sessionStorage.setItem(KEY_BEARER, value)
    sessionStorage.setItem(KEY_ACTIVE, '1')
    clearLegacyToken()
  } catch {
    /* ignore */
  }
}

export function getClienteBearerToken(): string | null {
  try {
    const t = sessionStorage.getItem(KEY_BEARER)
    return t && t.trim() ? t.trim() : null
  } catch {
    return null
  }
}

export function clearClienteToken(): void {
  try {
    sessionStorage.removeItem(KEY_ACTIVE)
    sessionStorage.removeItem(KEY_BEARER)
    clearLegacyToken()
  } catch {
    /* ignore */
  }
}

/** @deprecated Mantido por compatibilidade; use validação via API. */
export function isClienteAuthenticated(): boolean {
  return hasClienteSessionHint()
}

export async function logoutClienteApi(): Promise<void> {
  try {
    await fetchApi('/api/usuarios/logout', { method: 'POST' })
  } catch {
    /* ignore */
  }
}

export function logoutCliente(): void {
  clearClienteToken()
  void logoutClienteApi()
}
